module.exports = new __parcel__URL__("post-incident-reviewsDark.79dea6fc.svg").toString();